<template>
  <div id="shiori-schedule">
    <!-- <h2 class="shiori-title-sub">【 旅程 】 {{ shioriTitle }}</h2> -->
    <div id="schedule-boxes">
      <div class="schedule-box" 
      v-for="(dateObject, indexD) in dateObjects" :key="dateObject.date">
        <div class="schedule-date">
          <h2>{{ dateObject.date }}</h2> 
          <div class="date-btns">
            <button @click="editDate(indexD)"><i class="fas fa-pen fa-fw"></i></button>
            <button @click="deleteDate(indexD)"><i class="fas fa-trash-alt fa-fw"></i></button>
          </div>
        </div>
        <div class="schedule-time" 
        v-for="(event, indexE) in dateObject.events" :key="event.startTime">
          <h3 class="time">{{ event.startTime }}</h3>
          <button @click="editEvent(indexE, indexD)"><i class="fas fa-pen fa-fw"></i></button>
          <button @click="deleteEvent(indexE, indexD)"><i class="fas fa-trash-alt fa-fw"></i></button>
          <div class="event">
            <div class="event-title" @click="activeMemo(event)">
              <div class="event-title-icon"><i :class="event.icon"></i></div>
              <h3>{{ event.title }}</h3>
            </div>
            <div :class="['event-memo', {hidden: event.showMemo}]" 
            v-show="emptyAll(event.memo, event.link)">
              <pre v-show="emptyMemo(event.memo)" >{{ event.memo }}</pre>
              <div class="event-links" v-show="emptyLink(event.link)">
                <a :href="event.link" target="_blank">サイトリンク</a>
              </div>
            </div>
            <h3 class="end-time" v-show="emptyEndTime(event.endTime)"> ～ {{ event.endTime }}</h3>
          </div>
        </div>
        <div class="about-add-btn-box">
          <button class="about-add-btn" @click="eventBoxActive(indexD)">イベントを追加</button>
        </div>
      </div>
    </div>
    <div class="about-add-btn-box">
      <button class="about-add-btn" @click="dateBoxActive">日付を追加</button>
    </div>
    <MovePageBtn v-show="spWidth" 
    :last-page="{name:movePage.name, link:movePage.link}"></MovePageBtn>
    <MaskBox v-show="maskOn" ></MaskBox>
    <InputEvent v-show="maskOnE"
    @cancel="eventBoxCancel" 
    @new-event="addNewEvent" 
    @edit-event="replaceEvent"></InputEvent>
    <InputDate v-show="maskOnD"
    @cancel="dateBoxActive"
    @new-date="addNewDate"
    @edit-date="replaceDate"></InputDate>
  </div>
</template>

<script>
  import InputEvent from './InputBoxes/InputEvent.vue';
  import InputDate from './InputBoxes/InputDate.vue';

export default {
  props: {
    spWidth: {
      type: Boolean,
      required: true
    },
  },
  components: {
    InputEvent,
    InputDate,
  },
  data() {
    return {
      maskOn: false,
      maskOnE: false,
      maskOnD: false,
      newDate: "",
      newEeventObj: {},
      movePage: {
        name: "持ち物",
        link: "/items",
      }
    }
  },
  computed: {
    dateObjects: {
      get() {
        return this.$store.getters.dateObjects;
      },
      set(value) {
        this.$store.commit('dateObjects', value);
      }
    },
    editModeD: {
      get() {
        return this.$store.getters.editModeD;
      },
      set(value) {
        this.$store.commit('editModeD', value);
      }
    },
    editModeE: {
      get() {
        return this.$store.getters.editModeE;
      },
      set(value) {
        this.$store.commit('editModeE', value);
      }
    },
    editIndexD: {
      get() {
        return this.$store.getters.editIndexD;
      },
      set(value) {
        this.$store.commit('editIndexD', value);
      }
    },
    editIndexE: {
      get() {
        return this.$store.getters.editIndexE;
      },
      set(value) {
        this.$store.commit('editIndexE', value);
      }
    },
  },
  methods: {
    maskActive() {
      this.maskOn = !this.maskOn;
    },
    dateBoxActive() {
      this.maskOn = !this.maskOn;
      this.maskOnD = !this.maskOnD;
      this.editIndexD = "";
      this.editModeD = false;
    },
    eventBoxActive(index) {
      this.maskOn = !this.maskOn;
      this.maskOnE = !this.maskOnE;
      this.editIndexD = index;
    },
    eventBoxCancel() {
      this.maskOn = !this.maskOn;
      this.maskOnE = !this.maskOnE;
      this.editIndexD = "";
      this.editIndexE = "";
      this.editModeE = false;
      console.log("aaa");
    },
    emptyAll(valueA, valueB) {
      if (valueA === "" & valueB === "") {
        return false;
      } else {
        return true;
      }
    },
    emptyMemo(value) {
      if (value === "") {
        return false;
      } else {
        return true;
      }
    },
    emptyLink(value) {
      if (value === "") {
        return false;
      } else {
        return true;
      }
    },
    emptyEndTime(value) {
      if (value === "") {
        return false;
      } else {
        return true;
      }
    },
    addNewDate(inputEventDate) {
      this.maskOn = !this.maskOn;
      this.maskOnD = !this.maskOnD;
      this.newDate = {date:inputEventDate, events:[]}
      this.dateObjects = [...this.dateObjects, this.newDate];
    },
    editDate(index) {
      this.maskOn = !this.maskOn;
      this.maskOnD = !this.maskOnD;
      this.editIndexD = index;
      this.editModeD = true;
    },
    deleteDate(index) {
      const ret = confirm("削除してもよろしいですか？")
      if(ret === true) {
        this.dateObjects.splice(index, 1);
      } else {
        return;
      }
    },
    replaceDate(inputEventDate) {
      this.maskOn = !this.maskOn;
      this.maskOnD = !this.maskOnD;
      this.dateObjects[this.editIndexD].date = inputEventDate;
      this.editIndexD = "";
      this.editModeD = false;
    },
    addNewEvent(inputStart, inputIcon, inputTitle, inputMemo, inputLink, inputEnd) {
      this.newEventObj = {
        startTime:inputStart, 
        icon:inputIcon, 
        title:inputTitle, 
        memo:inputMemo, 
        showMemo: true,
        link:inputLink, 
        endTime:inputEnd
      };
      this.dateObjects[this.editIndexD].events = 
      [...this.dateObjects[this.editIndexD].events, this.newEventObj];
      this.sortTime(this.editIndexD);
      this.maskOn = !this.maskOn;
      this.maskOnE = !this.maskOnE;
      this.editIndexD = "";
    },
    editEvent(indexE, indexD) {
      this.maskOn = !this.maskOn;
      this.maskOnE = !this.maskOnE;
      this.editIndexD = indexD;
      this.editIndexE = indexE;
      this.editModeE = true;
    },
    deleteEvent(indexE, indexD) {
      const ret = confirm("削除してもよろしいですか？")
      if(ret === true) {
        this.dateObjects[indexD].events.splice(indexE, 1);
      } else {
        return;
      }
    },
    replaceEvent(inputStart, inputIcon, inputTitle, inputMemo, inputLink, inputEnd) {
      const dIndex = this.editIndexD;
      const eIndex = this.editIndexE
      this.dateObjects[dIndex].events[eIndex].startTime = inputStart;
      this.dateObjects[dIndex].events[eIndex].icon = inputIcon;
      this.dateObjects[dIndex].events[eIndex].title = inputTitle;
      this.dateObjects[dIndex].events[eIndex].memo = inputMemo;
      this.dateObjects[dIndex].events[eIndex].link = inputLink;
      this.dateObjects[dIndex].events[eIndex].endTime = inputEnd;
      this.sortTime(dIndex);
      this.maskOn = !this.maskOn;
      this.maskOnE = !this.maskOnE;
      this.editIndexD = "";
      this.editIndexE = "";
      this.editModeE = false;
    },
    activeMemo(event) {
      event.showMemo = !event.showMemo
    },
    sortTime(index) {
      this.dateObjects[index].events.sort((a, b) => {
        if(a.startTime > b.startTime) {
          return 1;
        } else {
          return -1;
        }
      });
    }
  },
}
</script>

<style>

</style>